// extracted by mini-css-extract-plugin
export default {"nav":"navbar_nav__pVa5o","active":"navbar_active__Ra2Ft","indicator":"navbar_indicator__Yy3wC"};